import { SVGProps } from 'react';
const IcTotal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.58935 1.64502C2.86778 1.12476 3.40995 0.799988 4.00003 0.799988H20C20.8837 0.799988 21.6 1.51633 21.6 2.39999V5.59999C21.6 6.48364 20.8837 7.19999 20 7.19999C19.1164 7.19999 18.4 6.48364 18.4 5.59999V3.99999H6.98965L11.7313 11.1125C12.0896 11.6499 12.0896 12.3501 11.7313 12.8875L6.98965 20H18.4V18.4C18.4 17.5163 19.1164 16.8 20 16.8C20.8837 16.8 21.6 17.5163 21.6 18.4V21.6C21.6 22.4836 20.8837 23.2 20 23.2H4.00003C3.40995 23.2 2.86778 22.8752 2.58935 22.355C2.31092 21.8347 2.34143 21.2034 2.66875 20.7125L8.47707 12L2.66875 3.28751C2.34143 2.79654 2.31092 2.16527 2.58935 1.64502Z'
      fill={props.fill || 'white'}
    />
  </svg>
);

export default IcTotal;
